import { render, staticRenderFns } from "./adjustData.vue?vue&type=template&id=75340c54&scoped=true"
import script from "./adjustData.vue?vue&type=script&lang=js"
export * from "./adjustData.vue?vue&type=script&lang=js"
import style0 from "./adjustData.vue?vue&type=style&index=0&id=75340c54&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75340c54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75340c54')) {
      api.createRecord('75340c54', component.options)
    } else {
      api.reload('75340c54', component.options)
    }
    module.hot.accept("./adjustData.vue?vue&type=template&id=75340c54&scoped=true", function () {
      api.rerender('75340c54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/commodityManagement/servingManagement/adjustData.vue"
export default component.exports